import { Service } from "@seriously-rad/seriouslyrad-framework-core/Service";
import { IPaperDimensionDto, IPrintReportTemplateDto } from "./Models";
import { NAMESPACE } from "./_Namespace";
import { ITypeInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/ITypeInfoMetadata";

export interface IGetDesignerInfoResponse
{
    amPmFormats: { [name: string]: string };
    booleanFormats: { [name: string]: string };
    currencySymbolFormats: { [name: string]: string };
    dayFormats: { [name: string]: string };
    fieldElementSpecialTypes: { [name: string]: string };
    fontFamilies: string[];
    horizontalAlignments: { [name: string]: string };
    hourFormats: { [name: string]: string };
    lineStyles: { [name: string]: string };
    minuteFormats: { [name: string]: string };
    monthFormats: { [name: string]: string };
    negativeFormats: { [name: string]: string };
    pageDimensions: { [name: string]: IPaperDimensionDto };
    paperOrientations: { [name: string]: string };
    paperSizes: { [name: string]: string };
    reportElements: IReportElementInfo[];
    reportTemplateTypeInfoMetadata: ITypeInfoMetadata;
    secondFormats: { [name: string]: string };
    timeFormats: { [name: string]: string };
    yearFormats: { [name: string]: string };
}


export class GetDesignerInfoResponse implements IGetDesignerInfoResponse
{
    public static classNamespace = NAMESPACE + "GetDesignerInfoResponse";
    public static className = "GetDesignerInfoResponse";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    amPmFormats!: { [name: string]: string };
    booleanFormats!: { [name: string]: string };
    currencySymbolFormats!: { [name: string]: string };
    dayFormats!: { [name: string]: string };
    fieldElementSpecialTypes!: { [name: string]: string };
    fontFamilies!: string[];
    horizontalAlignments!: { [name: string]: string };
    hourFormats!: { [name: string]: string };
    lineStyles!: { [name: string]: string };
    minuteFormats!: { [name: string]: string };
    monthFormats!: { [name: string]: string };
    negativeFormats!: { [name: string]: string };
    pageDimensions!: { [name: string]: IPaperDimensionDto };
    paperOrientations!: { [name: string]: string };
    paperSizes!: { [name: string]: string };
    reportElements!: IReportElementInfo[];
    reportTemplateTypeInfoMetadata!: ITypeInfoMetadata;
    secondFormats!: { [name: string]: string };
    timeFormats!: { [name: string]: string };
    yearFormats!: { [name: string]: string };

    public getReportElement(typeId: string)
    {
        const
            items = this.reportElements.filter(item => item.typeInfoMetadata.underlyingTypeId == typeId);

        if (!items.length)
            throw new Error(`Uunable to find report element for ${typeId}`)

        return items[0];
    }
}

export class GetDesignerInfoResponseService extends Service<GetDesignerInfoResponse>
{
}

export interface ILoadTemplateRequest
{
    printReportTemplateId: string;
}

export interface IRenderPreviewLayoutRequest
{
    template: IPrintReportTemplateDto;
}

export interface IReportElementInfo
{
    menuPath: string;
    typeInfoMetadata: ITypeInfoMetadata;
}

export interface ISaveTemplateRequest extends IPrintReportTemplateDto
{
}